import cn from 'classnames';

import { Link } from '@/components/Link';

import s from './DirectionSlide.module.scss';

interface SlideProps {
  image?: string;
  link: string;
  badge?: {
    name: string;
    position: string;
  };
  title: string;
  description: string;
  className?: string;
}

const DirectionSlide = ({
  title,
  link,
  description,
  className = '',
}: SlideProps) => {
  return (
    <Link
      href={link}
      prefetch={false}
      className={cn(s.root, className, 'link')}
      analyticsOptions={{
        action: link,
        clickZone: 'body',
        clickElement: 'cardclick',
        clickContent: title,
        uniqueId: `direction-${title}`,
        transitionType: 'inside-link',
        clickZoneCategory: 'site-body',
        transitionTypeMetrics: 'internal',
        transitionUrl: `/career/${link}`,
      }}
    >
      <div className={s.head} />
      <div className={s.content}>
        <h4 className={s.title}>{title}</h4>
        <p className={s.text}>{description}</p>
      </div>
    </Link>
  );
};

export { DirectionSlide };
